<template>
  <div id="sidebar-left-mobile" class="w-100 h-100">
    <div class="h-100 d-flex flex-column">
      <div class="h-100">

        <upload-item-medium v-if="activeStage.mainJob === null"></upload-item-medium>
        <draw-item-mobile v-if="activeStage.activeStep === 'draw'"></draw-item-mobile>
        <prompt-item-medium v-if="activeStage.activeStep === 'prompt'"></prompt-item-medium>
        <settings-item-medium v-if="activeStage.activeStep === 'settings'"></settings-item-medium>
        <generate-item v-if="activeStage.activeStep === 'generate'"></generate-item>
        <select-output-item v-if="activeStage.activeStep === 'select_output'"></select-output-item>
      </div>


    </div>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin';
import currentJob from './../../mixins/current_job.mixin';
import GenerateBtn from "../Elements/GenerateBtn.vue";
import Prompt from "../Elements/Prompt.vue";
import UploadItem from "./Items/UploadItem.vue";
import DrawItem from "./Items/DrawItem.vue";
import PromptItem from "./Items/PromptItem.vue";
import SettingsItem from "./Items/SettingsItem.vue";
import GenerateItem from "./Items/GenerateItem.vue";
import SelectOutputItem from "./Items/SelectOutputItem.vue";
import DrawItemMobile from "./Items/DrawItemMobile.vue";
import PromptItemMobile from "./Items/PromptItemMobile.vue";
import PromptItemMedium from "./Items/PromptItemMedium.vue";
import SettingsItemMedium from "./Items/SettingsItemMedium.vue";
import UploadItemMedium from "./Items/UploadItemMedium.vue";

export default {
  name: 'SidebarLeftSettingsMobile',
  props: {},
  components: {
    UploadItemMedium,
    SettingsItemMedium,
    PromptItemMedium,
    PromptItemMobile,
    DrawItemMobile,
    SelectOutputItem,
    GenerateItem,
    SettingsItem,
    PromptItem,
    DrawItem,
    UploadItem,
    Prompt,
    GenerateBtn
  },
  mixins: [store, currentJob],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {},
  computed: {},
};
</script>
<style lang="scss">
.main-number {
  font-size: 24px;
  font-weight: bold;
  border: 2px solid white;
  border-radius: 50%;
  display: flex;
  width: 50px;
  height: 50px;
  align-items: center;
  justify-content: center;

  &.done {
    border: 2px solid #00C851;
    color: #00C851;
  }
}

.sidebar-item {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px 20px;
  border-bottom: 1px solid #595959;
  width: 100%;
  background: #272727;
  color: white;
}

.btn-box {
  min-height: 105px;
  height: 105px;
}

.gap-10 {
  gap: 10px;
}

#sidebar-left {
  width: 400px;
  min-width: 400px;
  background: #383838;
  border-right: 1px solid #595959;

  display: flex;
  flex-direction: column;

  .sidebar-top {
    flex: 1 1 auto;
    overflow-y: auto;
  }

  .sidebar-bot {
    background: #272727;
    border-top: 1px solid #595959;
  }
}

#sidebar-left {
  width: 400px;
  min-width: 400px;
  background: white;
  border-right: 1px solid #595959;
  height: 100%;

  .dark-mode & {
    border-right: 1px solid #595959;
    background: #272727;
  }

  display: flex;
  flex-direction: column;

  .sidebar-top {
    flex: 1 1 auto;
    overflow-y: auto;
  }

  .sidebar-bot {
    background: #272727;
    border-top: 1px solid #595959;
  }
}
</style>
